/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClosePosSessionDto } from '../../models/close-pos-session-dto';
import { CloseSessionResponseDto } from '../../models/close-session-response-dto';

export interface PosSessionsControllerClose$Params {
  id: string;
      body: ClosePosSessionDto
}

export function posSessionsControllerClose(http: HttpClient, rootUrl: string, params: PosSessionsControllerClose$Params, context?: HttpContext): Observable<StrictHttpResponse<CloseSessionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerClose.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CloseSessionResponseDto>;
    })
  );
}

posSessionsControllerClose.PATH = '/pos/sessions/{id}/close';
